import React from "react";
export var AuthContext = React.createContext(undefined);
